import { StyleSheet } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import cloneDeep from 'lodash.clonedeep';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

const commonStyle: { [propName: string]: {} } = {
    contentWrapper: {
        flexDirection: 'row',
        flex: 1
    },
    left: {
        flex: 1,
        // backgroundColor:'red',
    },
    right: {
        position:'relative',
        // backgroundColor:'#999',
        minWidth: 85,
        paddingLeft: 10,
        alignItems: 'flex-end'
    },
    priceBubble:{
        position:'absolute',
        top:20,
        right:0,
        width:84,
        height:20
    },
    priceBubbleBox:{
        width:84,
        height:20,
        alignItems: 'center',
        justifyContent:'center',
    },
    priceBubbleImage:{
        width:'100%',
        height:'100%'
    },
    ticketItemWithSiblings: {
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderStyle: 'solid',
        borderBottomColor: '#eee',
        paddingBottom: 10,
        marginBottom: 10
    },
    orderName: {
        flexDirection: 'row',
        marginBottom: 5,
        overflow: 'hidden'
    },
    orderNameText: {
        fontSize: 16,
        color: '#333',
        lineHeight: 16 * 1.7
    },
    arrowLineIcon: {
        fontSize: 14,
        color: '#999'
    },
    orderDate: {
        flex: 1,
        justifyContent: 'center'
    },
    orderDateText: {
        fontSize: 12,
        lineHeight: 12 * 1.5,
        color: '#666'
    },
    orderItemTag: {
        flex: 1,
        justifyContent: 'center',
        height: 18
    },
    orderItemTagText: {
        lineHeight: 12 * 1.5,
        fontSize: 12,
        color: '#999'
    },
    flexCenter: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    // 新版样式
    // 主标题
    newOrderTitle: {
        flexShrink: 1,
        lineHeight: 16 * 1.25,
        fontSize: 16,
        color: baseColor.text1,
        fontWeight: DeviceInfo.isIOS ? '600' : '400',
        marginBottom: 6
    },
    // 副标题
    newOrderSubTitle: {
        lineHeight: 20,
        fontSize: 13,
        color: baseColor.text3
    },
    // +2天
    oneMoreDay: {
        fontSize: 12,
        color: '#00bcd4'
    },
    // 带有icon的一行
    rowWithIcon: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    // 车车等 往返黄蓝点
    dot: {
        width: 6,
        height: 6,
        backgroundColor: '#00BCD4',
        borderRadius: 3,
        marginRight: 8
    },
    dotDist: {
        backgroundColor: '#FF9800'
    },
    ml14: {
        marginLeft: 14
    },
    ml22: {
        marginLeft: 22
    },
    mt16: {
        marginTop: 16
    },
    mb6: {
        marginBottom: 6
    },
    flex1: {
        flex: 1
    },
    // 车车，机票，去返
    textIconWrapper: {
        overflow: 'hidden',
        width: 14,
        height: 14,
        borderRadius: 7,
        backgroundColor: '#75d011',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 8,
        marginBottom: 6
    },
    // 返另外一个颜色
    back: {
        backgroundColor: '#ff9800'
    },
    textIcon: {
        fontSize: 10
    },
    childTicketWrapper:{
        overflow: 'hidden',
        // width: 36,
        height: 16,
        borderRadius: 8,
        // backgroundColor: '#F3F6F8',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft:6,
        marginBottom: 5,
        paddingHorizontal: 4
    },
    childTicketText:{
        fontSize: 10,
        color: '#6285A0',
        fontWeight:'400'
    },
    // 价格区域
    orderBodyRight: {
        width: 85
    },
    // 价格包裹
    orderPriceWrapper: {
        marginTop: DeviceInfo.isIOS ? 2 : 0,
        width: 85,
        textAlign: 'right',
        lineHeight: 16 * 1.25,
        color: '#424242'
    },
    // 货币符号
    orderPriceCurrency: {
        fontSize: 12
    },
    orderExtraPriceCurrency: {
        fontSize: 9
    },
    // 价格数字
    orderPrice: {
        fontSize: 17
    },
    originOrderPrice: {
        color: '#CCCCCC',
        fontSize: 12,
        textDecorationLine: 'line-through',
        marginTop: -3
    },
    // 约合￥ 666
    orderPriceConvert: {
        fontSize: 12
    },
    // 车车 价格区 折券
    priceTextIconBox: {
        marginTop: DeviceInfo.isIOS ? 2 : 0,
        width: 85,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    // 车车 价格区 折券边框
    priceTextIconWrapper: {
        width: 16,
        height: 16,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#f5a623',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 4
    },
    // 券另外一个颜色
    coupon: {
        borderColor: '#00bcd4'
    },
    // 车车 价格区 折券文字
    priceTextIconText: {
        fontSize: 10,
        color: '#f5a623'
    },
    // 券另外一个颜色
    couponText: {
        color: '#00bcd4'
    },
    // 带转字的一行
    transferRow: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    // 转字和icon的容器
    transferWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 6,
        overflow: 'hidden'
    },
    // 转字的容器
    transferTextWrapper: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 7,
        height: 14,
        borderWidth: 0.5,
        borderColor: baseColor.text1,
        borderRadius: 7
    },
    transferTextWrapperSub: {
        borderColor: baseColor.text3
    },
    transferIcon: {
        color: baseColor.text1
    },
    transferIconSub: {
        fontSize: 10,
        color: baseColor.text3
    },
    // 转字
    transferText: {
        fontSize: 10,
        color: baseColor.text1
    },
    transferTextSub: {
        color: baseColor.text3
    },
    greyTipNoticeIcon: {
        marginTop: 6,
        color: baseColor.text3,
        width: 14,
        height: 14,
        fontSize: 14,
        marginRight: 8
    },
    greyTipNoticeText: {
        marginTop: 6,
        fontSize: 13,
        color: baseColor.text3
    },
    // 服务进度
    cardProgress: {
        marginTop: 5,
        paddingHorizontal: 12,
        paddingVertical: 10,
        borderRadius: 6
    },
    cardProgressTitle: {
        color: '#333333',
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 5
    },
    cardProgressDesc: {
        color: '#999999',
        fontSize: 11,
        lineHeight: 12
    },
    carIcon: {
        width: 14,
        height: 14,
        marginRight: 8
    }
};

const disableStyle = (styles: any) => {
    const colorKeys = ['color', 'borderColor', 'backgroundColor'];
    const result = cloneDeep(styles);

    Object.keys(result).forEach((key) => {
        colorKeys.forEach((colorKey) => {
            if (styles[key][colorKey] !== undefined) {
                result[key][colorKey] = baseColor.disableText;
            }
        });
    });

    return result;
};

export const enabledStyle = StyleSheet.create(commonStyle);

export const disabledStyle = StyleSheet.create(disableStyle(commonStyle));
